import { all } from 'redux-saga/effects';

import searchSaga from './requestSearch';
import programDetails from './programDetails';

export default function* rootSaga() {
  yield all([searchSaga(), programDetails()]);
}
